export default __webpack_public_path__ + "static/media/0368.6e51c483.jpg";